import React from 'react'

const YinsureIcon = ({ color }) => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M12.0207 23.088C6.82857 20.7492 3.14307 17.8886 3.14307 12V5.15862C3.14307 5.04683 3.20826 4.94532 3.3099 4.89881L12.0242 0.911525C12.0997 0.876985 12.1865 0.876985 12.2619 0.911525L20.9762 4.89881C21.0779 4.94532 21.1431 5.04683 21.1431 5.15862V12C21.1431 18.0078 17.2623 20.6355 12.2634 23.084C12.1875 23.1212 12.0978 23.1227 12.0207 23.088ZM5.42878 6.44292L12.1431 3.37075V11.7143L5.42878 11.7143V6.44292ZM12.1431 20.5884V11.7143H18.8574V12C18.8574 14.4319 18.102 16.0328 16.9046 17.3196C15.7752 18.5332 14.1847 19.5419 12.1431 20.5884Z'
        fill={color}
      />
    </svg>
  )
}

export default YinsureIcon
